'use client'
import React from "react";
import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import Link from "next/link";
import {getBreadcrumbs} from "@/components/Breadcrumbs/BreadcrumbProvider";
import clsx from "clsx";

interface Props {
    className?: string
}

const Breadcrumbs = ({className}:Props) => {
    const breadcrumbs = getBreadcrumbs();
    let slug = '';
    return (
        <ul className={"w-fit pl-[0px] mx-auto md:mx-[0px] list-none my-[0px] flex items-center justify-center md:justify-start flex-wrap gap-y-s gap-x-m " + className}>
            {breadcrumbs.map((item, index) => {
                slug += `/${item.slug}`;
                return (
                    <li key={index} className={clsx('flex items-center')}>
                        {index === breadcrumbs.length - 1 ? (
                            item.title
                        ) : (
                            <Link href={slug}
                                  className={clsx(index !== breadcrumbs.length - 1 ? 'opacity-70 hover:opacity-100 hover:underline brand-transition' : '')}>
                                {item.title}
                            </Link>
                        )}
                        {index !== breadcrumbs.length - 1 ?
                            <IconRenderer icon="icon-arrow" className="ml-m right-[16px] w-[16px]"/> : null}
                    </li>
                );
            })}
        </ul>
    )
}

export default Breadcrumbs;